import { createContext, FC, PropsWithChildren, useContext } from 'react';

interface PageContext {
    pageIndex: number | null;
}

interface Props extends PropsWithChildren {
    pageIndex: number;
}

const PageContext = createContext<PageContext>({ pageIndex: null });

export const PageProvider: FC<Props> = ({ children, pageIndex }) => {
    return (
        <PageContext.Provider value={{ pageIndex }}>
            {children}
        </PageContext.Provider>
    );
};

export const usePageContext = () => useContext<PageContext>(PageContext);
